import { render, staticRenderFns } from "./IncorporationPopupDetails.vue?vue&type=template&id=1435a788&scoped=true&"
import script from "./IncorporationPopupDetails.vue?vue&type=script&lang=js&"
export * from "./IncorporationPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncorporationPopupDetails.vue?vue&type=style&index=0&id=1435a788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435a788",
  null
  
)

export default component.exports